import React from "react";
import { Pill } from "@/lib/retention";
import { CRIT_STYLES, DEF_STYLES, EFF_STYLES, EVID_STYLES, EXEC_STYLES, STATUS_STYLES, lbl } from "@/lib/controls";
import { NONE, Pick } from "@/components/vendors/NewVendorDialog";

export { Pill };
const th = "px-3 py-2.5 font-semibold";
export const Head = ({ cols }) => (
  <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500 border-b border-slate-100">{cols.map((h, i) => <th key={i} className={th}>{h}</th>)}</tr></thead>
);
export const Box = ({ children, testId }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto"><table className="w-full text-sm" data-testid={testId}>{children}</table></div>
);
export const Empty = ({ cols, text }) => <tr><td colSpan={cols} className="px-4 py-8 text-center text-xs text-slate-500">{text}</td></tr>;
export const Card = ({ title, children, action, testId, className = "" }) => (
  <section className={`bg-white border border-slate-200 rounded-xl p-5 ${className}`} data-testid={testId}>
    {(title || action) && <div className="flex items-center justify-between mb-3"><h3 className="text-sm font-semibold text-[#003366]">{title}</h3>{action}</div>}
    {children}
  </section>
);
export const Stat = ({ label, value, tone = "text-[#003366]", testId, hint }) => (
  <div className="bg-white border border-slate-200 rounded-xl px-4 py-3" data-testid={testId}>
    <div className="text-[11px] uppercase tracking-wide text-slate-500">{label}</div>
    <div className={`text-2xl font-bold mt-1 ${tone}`}>{value ?? "-"}</div>
    {hint && <div className="text-[11px] text-slate-400">{hint}</div>}
  </div>
);
export const StatusPill = ({ s, testId }) => <Pill cls={STATUS_STYLES[s] || ""} testId={testId}>{lbl(s)}</Pill>;
export const EffPill = ({ s, testId }) => <Pill cls={EFF_STYLES[s] || EFF_STYLES.NOT_TESTED} testId={testId}>{lbl(s || "NOT_TESTED")}</Pill>;
export const CritPill = ({ s }) => <Pill cls={CRIT_STYLES[s] || ""}>{lbl(s)}</Pill>;
export const ExecPill = ({ s, testId }) => <Pill cls={EXEC_STYLES[s] || ""} testId={testId}>{lbl(s)}</Pill>;
export const EvidPill = ({ s, testId }) => <Pill cls={EVID_STYLES[s] || ""} testId={testId}>{lbl(s)}</Pill>;
export const DefPill = ({ s, testId }) => <Pill cls={DEF_STYLES[s] || ""} testId={testId}>{lbl(s)}</Pill>;
export const Demo = ({ on }) => (on ? <span className="ml-1.5 text-[9px] font-bold tracking-wider px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 align-middle">DEMO</span> : null);
export const MemberPick = ({ meta, value, onChange, testId, none = "Unassigned" }) => (
  <Pick value={value || NONE} onChange={(v) => onChange(v === NONE ? null : v)} testId={testId} none={none}
        options={(meta?.members || []).map((m) => [m.membership_id, `${m.name} (${m.roles?.[0] || "-"})`])} />
);
export const KV = ({ k, v, testId }) => (
  <div className="py-1.5 flex gap-3 text-sm border-b border-slate-50 last:border-0"><div className="w-40 shrink-0 text-slate-500 text-xs pt-0.5">{k}</div><div className="text-[#003366]" data-testid={testId}>{v ?? "-"}</div></div>
);
